import { jsx, jsxs } from 'react/jsx-runtime';

function _define_property$13(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$13(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$13(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$13(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$13(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$13(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgAddEmoji = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$13(_object_spread$13({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 21 21",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M10.398.607c.583 0 1.16.047 1.728.14a1 1 0 0 1-.324 1.974 8.656 8.656 0 0 0-1.404-.114C5.755 2.607 2 6.28 2 10.803S5.755 19 10.398 19c4.642 0 8.397-3.675 8.397-8.197a8 8 0 0 0-.655-3.18 1 1 0 1 1 1.836-.792 10 10 0 0 1 .82 3.972C20.795 16.44 16.135 21 10.397 21 4.66 21 0 16.44 0 10.803 0 5.167 4.66.607 10.398.607m3.73 12.41c.82.161 1.076.651.929 1.33-.372 1.725-2.187 2.88-4.607 2.894-2.448.015-4.327-1.153-4.709-2.921-.147-.67.071-1.153.922-1.32a19.25 19.25 0 0 1 7.465.017m-6.55-6.812c1.038 0 1.88.824 1.88 1.84 0 1.015-.842 1.839-1.88 1.839-1.038 0-1.88-.824-1.88-1.84 0-1.015.842-1.839 1.88-1.839m5.639 0c1.038 0 1.88.824 1.88 1.84 0 1.015-.842 1.839-1.88 1.839-1.038 0-1.88-.824-1.88-1.84 0-1.015.842-1.839 1.88-1.839M16.942 0c.316 0 .474.27.474.81v1.363H18.8c.552 0 .828.162.828.485 0 .31-.276.464-.828.464h-1.383v1.353c0 .54-.158.81-.474.81-.337 0-.505-.27-.505-.81V3.122h-1.383c-.552 0-.828-.155-.828-.464 0-.323.276-.485.828-.485h1.383V.81c0-.54.168-.81.505-.81"
        })
    }));
};

function _define_property$12(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$12(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$12(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$12(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$12(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$12(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgArrowDown = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$12(_object_spread$12({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 12 8",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M10.513 0 12 1.589 6 8 0 1.589 1.487 0 6 4.822z"
        })
    }));
};

function _define_property$11(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$11(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$11(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$11(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$11(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$11(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgBackArrow = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$11(_object_spread$11({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 23 22",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "m11.078.588 1.334 1.49L4.117 9.5H22.5v2H3.915l8.5 8.5L11 21.414l-9.538-9.538-.04.036-.651-.727-.685-.685.038-.038-.036-.04.727-.651.685-.685.038.037 9.54-8.535"
        })
    }));
};

function _define_property$10(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$10(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$10(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$10(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$10(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$10(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgBought = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$10(_object_spread$10({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 15 13",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "m12.94-.06 2.12 2.12L5 12.122l-5.06-5.06 2.12-2.122L5 7.88z"
        })
    }));
};

function _define_property$$(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$$(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$$(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$$(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$$(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$$(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgCalendar = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$$(_object_spread$$({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M4 0v1.6h8V0h2v1.6h1.66a.34.34 0 0 1 .34.34v13.72a.34.34 0 0 1-.34.34H.34a.34.34 0 0 1-.34-.34V1.94a.34.34 0 0 1 .34-.34H2V0zm10.678 6.267H1.323a.24.24 0 0 0-.242.242v7.957c0 .134.108.242.242.242h13.355a.24.24 0 0 0 .242-.242V6.509a.24.24 0 0 0-.242-.242m-1.078 4.2c.184 0 .334.149.334.333v2.667c0 .184-.15.333-.334.333h-2.666a.333.333 0 0 1-.334-.333V10.8c0-.184.15-.333.334-.333Z"
        })
    }));
};

function _define_property$_(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$_(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$_(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$_(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$_(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$_(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgCastCredit = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$_(_object_spread$_({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 21 22",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M0 12.497v9.168c0 .185.15.335.337.335H11.63c.09 0 .176-.036.239-.098l9.07-8.975a.167.167 0 0 0-.12-.285h-5.342a.168.168 0 0 0-.168.168v3.76a.168.168 0 0 1-.168.168H6.81a.168.168 0 0 1-.169-.167V6.663c0-.093.076-.168.169-.168h8.272a.17.17 0 0 1 .17.169v3.09c0 .093.075.168.168.168h5.413A.166.166 0 0 0 21 9.756V.166A.166.166 0 0 0 20.833 0h-8.392a.338.338 0 0 0-.237.097L.258 11.881a.865.865 0 0 0-.258.616"
        })
    }));
};

function _define_property$Z(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$Z(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$Z(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$Z(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$Z(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$Z(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgCategories = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$Z(_object_spread$Z({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 16",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M7 0h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1M1 0h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1m6 6h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1M1 6h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1m6 6h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1m-6 0h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1"
        })
    }));
};

function _define_property$Y(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$Y(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$Y(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$Y(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$Y(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$Y(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgChannelPass = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$Y(_object_spread$Y({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 63.135 64",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            fillRule: "nonzero",
            d: "M34.886 49.038 45.692 38.07a5.317 5.317 0 0 0 1.235-1.92c.257-.704.386-1.448.386-2.232 0-1.67-.58-3.094-1.737-4.27-1.158-1.174-2.56-1.762-4.206-1.762-1.03 0-2.058.34-3.088 1.019-1.029.679-2.16 1.775-3.396 3.29-1.235-1.515-2.367-2.611-3.396-3.29-1.029-.68-2.058-1.019-3.087-1.019-1.646 0-3.049.588-4.206 1.763-1.158 1.175-1.737 2.598-1.737 4.27 0 .783.129 1.527.386 2.232a5.317 5.317 0 0 0 1.235 1.919l10.805 10.967m3.165 13.395C36.97 63.478 35.697 64 34.23 64c-1.467 0-2.74-.522-3.821-1.567L1.466 33.058C.9 32.483.515 31.869.31 31.217A6.864 6.864 0 0 1 0 29.14V5.327c0-1.515.502-2.781 1.505-3.8C2.508.51 3.756 0 5.248 0h23.464c.72 0 1.428.104 2.122.313.695.21 1.325.6 1.891 1.175l28.79 29.22c1.08 1.096 1.62 2.402 1.62 3.916 0 1.515-.54 2.846-1.62 3.995L38.05 62.433M13.353 17.547c1.08 0 2.02-.405 2.817-1.214.797-.81 1.196-1.763 1.196-2.86 0-1.096-.399-2.05-1.196-2.859-.798-.809-1.737-1.214-2.817-1.214-1.081 0-2.02.405-2.818 1.214-.797.81-1.196 1.763-1.196 2.86 0 1.096.399 2.05 1.196 2.859.798.81 1.737 1.214 2.818 1.214"
        })
    }));
};

function _define_property$X(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$X(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$X(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$X(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$X(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$X(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgChannels = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$X(_object_spread$X({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 21",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M1 0h6.995a1 1 0 0 1 1 1v6.995a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1m11.005 0H19a1 1 0 0 1 1 1v6.995a1 1 0 0 1-1 1h-6.995a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1M1 11.012h6.995a1 1 0 0 1 1 1v6.995a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-6.995a1 1 0 0 1 1-1m11.005 0H19a1 1 0 0 1 1 1v6.995a1 1 0 0 1-1 1h-6.995a1 1 0 0 1-1-1v-6.995a1 1 0 0 1 1-1"
        })
    }));
};

function _define_property$W(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$W(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$W(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$W(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$W(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$W(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgCheckCircleFilled = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$W(_object_spread$W({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0ZM8 15l-5-5 1.41-1.41L8 12.17l7.59-7.59L17 6l-9 9"
        })
    }));
};

function _define_property$V(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$V(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$V(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$V(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$V(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$V(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgCog = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$V(_object_spread$V({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 46 48",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "#1E211D",
            fillRule: "evenodd",
            d: "M33.621 0 46 12.032V46a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V11.83h11.572V0h22.05m-8.36 15.652h-3.476a.592.592 0 0 0-.383.133c-.11.089-.17.2-.18.336l-.439 2.875c-.511.167-.98.36-1.409.578l-2.207-1.672a.564.564 0 0 0-.391-.14.54.54 0 0 0-.392.171c-1.315 1.188-2.176 2.063-2.583 2.625a.61.61 0 0 0 .016.72c.156.218.423.564.798 1.038.376.474.658.841.846 1.102a7.723 7.723 0 0 0-.642 1.547l-2.865.422a.494.494 0 0 0-.329.195.59.59 0 0 0-.125.367v3.469c0 .125.042.245.125.36a.471.471 0 0 0 .298.202l2.911.438c.147.479.35.958.611 1.437a35.574 35.574 0 0 1-1.675 2.157.587.587 0 0 0-.157.375c0 .104.047.224.141.359.272.375.786.935 1.542 1.68.757.744 1.25 1.117 1.48 1.117a.667.667 0 0 0 .407-.156l2.16-1.672c.46.24.934.437 1.425.593.167 1.417.318 2.386.454 2.907.073.291.26.437.563.437h3.475a.592.592 0 0 0 .384-.133c.11-.088.17-.2.18-.336l.438-2.875c.512-.166.981-.359 1.41-.578l2.222 1.672c.094.094.22.14.376.14a.606.606 0 0 0 .391-.155c1.347-1.24 2.208-2.125 2.583-2.657a.504.504 0 0 0 .11-.343.602.602 0 0 0-.125-.36 30.135 30.135 0 0 0-.799-1.039 32.991 32.991 0 0 1-.845-1.101c.271-.521.485-1.032.642-1.532l2.864-.437a.494.494 0 0 0 .33-.196.59.59 0 0 0 .124-.367v-3.468a.602.602 0 0 0-.125-.36.477.477 0 0 0-.313-.203l-2.896-.437a10 10 0 0 0-.61-1.422c.365-.521.923-1.24 1.675-2.157a.603.603 0 0 0 .156-.39.52.52 0 0 0-.14-.36c-.283-.385-.8-.947-1.55-1.687-.752-.74-1.243-1.11-1.472-1.11a.765.765 0 0 0-.407.141l-2.16 1.688a8.941 8.941 0 0 0-1.425-.594c-.167-1.417-.318-2.385-.454-2.906-.073-.292-.261-.438-.564-.438M24.044 24c1.155 0 2.14.408 2.957 1.223.817.815 1.225 1.799 1.225 2.95 0 1.153-.408 2.137-1.225 2.952-.817.815-1.802 1.223-2.957 1.223-1.154 0-2.14-.408-2.956-1.223-.817-.815-1.225-1.799-1.225-2.951 0-1.152.408-2.136 1.225-2.951.817-.815 1.802-1.223 2.956-1.223"
        })
    }));
};

function _define_property$U(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$U(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$U(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$U(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$U(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$U(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgCross = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$U(_object_spread$U({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 21.789 21.789",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "m17.207 6.4-1.819-1.819-4.537 4.538-4.582-4.581-1.731 1.731 4.58 4.582-4.537 4.537 1.82 1.82 4.537-4.538 4.582 4.581 1.731-1.731-4.581-4.582z"
        })
    }));
};

function _define_property$T(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$T(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$T(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$T(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$T(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$T(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgDataProfile = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$T(_object_spread$T({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 18",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M10.012 9.272c.328 0 .595.266.595.595v4.521c0 .329.188.784.421 1.017l2.07 2.07c.233.233.155.421-.174.421H.596A.595.595 0 0 1 0 17.301v-1.347a6.682 6.682 0 0 1 6.683-6.682Zm9.89-3.339c.33 0 .785.19 1.017.421l2.66 2.661c.233.232.421.687.421 1.016v3.762c0 .33-.188.784-.42 1.017l-2.66 2.66c-.233.232-.689.421-1.018.421H16.14c-.328 0-.783-.189-1.016-.42l-2.66-2.66c-.233-.234-.42-.689-.42-1.018v-3.762c0-.329.187-.784.42-1.016l2.66-2.66c.233-.233.688-.422 1.016-.422h3.762m-.59 1.426h-2.58c-.33 0-.785.188-1.018.421L13.89 9.605c-.232.233-.42.688-.42 1.017v2.581c0 .33.188.784.42 1.016l1.825 1.825c.233.233.688.422 1.017.422h2.581c.33 0 .784-.189 1.017-.422l1.825-1.825c.232-.232.421-.687.421-1.016v-2.58c0-.33-.189-.785-.42-1.018L20.328 7.78c-.233-.233-.688-.42-1.017-.42m-2.497 1.674c.015 0 .029.006.039.016l1.128 1.19a.056.056 0 0 0 .04.016.056.056 0 0 0 .039-.017l1.128-1.189a.055.055 0 0 1 .039-.016h.989c.008 0 .016.003.022.01l.757.756a.5.5 0 0 1 .146.354v1.925a.5.5 0 0 1-.146.354l-2.845 2.831h-.259l-2.845-2.83a.5.5 0 0 1-.146-.355v-1.925a.5.5 0 0 1 .146-.354l.757-.757a.031.031 0 0 1 .022-.009ZM8.745 0a4.256 4.256 0 1 1 0 8.512 4.256 4.256 0 0 1 0-8.512"
        })
    }));
};

function _define_property$S(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$S(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$S(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$S(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$S(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$S(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgDelete = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$S(_object_spread$S({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 41 55",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "#000",
            fillRule: "nonzero",
            d: "M5.79 52.386C5.85 53.847 7.032 55 8.47 55H33.53c1.438 0 2.621-1.153 2.682-2.614L38 14H4l1.79 38.386m20.878-28.852a1.1 1.1 0 0 1 1.09-1.107h1.744a1.1 1.1 0 0 1 1.09 1.107v21.932a1.1 1.1 0 0 1-1.09 1.107H27.76a1.1 1.1 0 0 1-1.09-1.107V23.534m-7.63 0a1.1 1.1 0 0 1 1.09-1.107h1.744a1.1 1.1 0 0 1 1.09 1.107v21.932c0 .611-.488 1.107-1.09 1.107h-1.744c-.602 0-1.09-.495-1.09-1.107V23.534m-7.63 0a1.1 1.1 0 0 1 1.09-1.107h1.743a1.1 1.1 0 0 1 1.09 1.107v21.932c0 .611-.488 1.107-1.09 1.107h-1.743c-.602 0-1.09-.495-1.09-1.107V23.534M39.262 2.826H27.34V.578c0-.32-.26-.578-.58-.578H14.24c-.32 0-.58.259-.58.578v2.248H1.737C.777 2.826 0 3.6 0 4.558V10h41V4.558c0-.957-.778-1.732-1.737-1.732Z"
        })
    }));
};

function _define_property$R(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$R(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$R(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$R(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$R(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$R(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgEventCalendar = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$R(_object_spread$R({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 14 15",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M5 0v1.5h4V0h3v1.5h1.5v13H.5v-13H2V0zm7.5 5h-11v8.5h11z"
        })
    }));
};

function _define_property$Q(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$Q(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$Q(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$Q(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$Q(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$Q(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgEventCountdown = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$Q(_object_spread$Q({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 14 16",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M7 1.5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10M7.5 5v3h3v1h-4V5zm1-5v1h-3V0z"
        })
    }));
};

function _define_property$P(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$P(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$P(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$P(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$P(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$P(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgExchangeChannelPass = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$P(_object_spread$P({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 60.073 60",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("g", {
            fill: "#000",
            fillRule: "nonzero",
            children: /*#__PURE__*/ jsx("path", {
                d: "m33.195 45.973 10.281-10.281a4.977 4.977 0 0 0 1.175-1.8 5.977 5.977 0 0 0 .367-2.093c0-1.566-.55-2.9-1.652-4.002-1.102-1.102-2.436-1.653-4.002-1.653-.98 0-1.959.319-2.938.955-.98.637-2.056 1.665-3.231 3.085-1.175-1.42-2.253-2.448-3.232-3.085-.979-.636-1.958-.955-2.937-.955-1.567 0-2.901.551-4.003 1.653-1.101 1.101-1.652 2.436-1.652 4.002 0 .735.122 1.432.367 2.093s.637 1.261 1.175 1.8l10.282 10.281m3.01 12.558c-1.028.98-2.24 1.469-3.635 1.469-1.395 0-2.607-.49-3.635-1.469l-27.54-27.54C.857 30.453.49 29.878.294 29.266A6.348 6.348 0 0 1 0 27.319V4.994c0-1.42.477-2.607 1.432-3.562C2.387.477 3.574 0 4.994 0h22.325c.686 0 1.36.098 2.02.294.661.196 1.26.563 1.8 1.101L58.53 28.788c1.028 1.028 1.542 2.252 1.542 3.672 0 1.42-.514 2.669-1.542 3.746L36.206 58.53m-23.5-42.08c1.028 0 1.922-.38 2.68-1.139.76-.759 1.139-1.652 1.139-2.68 0-1.029-.38-1.922-1.138-2.681-.76-.759-1.653-1.138-2.681-1.138s-1.922.38-2.68 1.138c-.76.759-1.139 1.652-1.139 2.68 0 1.029.38 1.922 1.138 2.681.76.759 1.653 1.138 2.681 1.138M47.86 12.8 44 8.94l3.86-3.86.84.84-2.42 2.42h6.32v1.2h-6.32l2.42 2.42zm8.28-5.08-.84-.84 2.42-2.42H51.4v-1.2h6.32L55.3.84l.84-.84L60 3.86z"
            })
        })
    }));
};

function _define_property$O(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$O(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$O(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$O(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$O(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$O(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgFan = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$O(_object_spread$O({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 18",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M10.012 9.272c.328 0 .595.266.595.595v4.521c0 .329.188.784.421 1.017l2.07 2.07c.233.233.155.421-.174.421H.596A.595.595 0 0 1 0 17.301v-1.347a6.68 6.68 0 0 1 6.683-6.682Zm9.89-3.339c.33 0 .785.19 1.017.421l2.66 2.661c.233.232.421.687.421 1.016v3.762c0 .33-.188.784-.42 1.017l-2.66 2.66c-.233.232-.689.421-1.018.421H16.14c-.328 0-.783-.189-1.016-.42l-2.66-2.66c-.233-.234-.42-.689-.42-1.018v-3.762c0-.329.187-.784.42-1.016l2.66-2.66c.233-.233.688-.422 1.016-.422zm-.59 1.426h-2.58c-.33 0-.785.188-1.018.421L13.89 9.605c-.232.233-.42.688-.42 1.017v2.581c0 .33.188.784.42 1.016l1.825 1.825c.233.233.688.422 1.017.422h2.581c.33 0 .784-.189 1.017-.422l1.825-1.825c.232-.232.421-.687.421-1.016v-2.58c0-.33-.189-.785-.42-1.018L20.328 7.78c-.233-.233-.688-.42-1.017-.42m-2.497 1.674q.023 0 .039.016l1.128 1.19a.06.06 0 0 0 .04.016.06.06 0 0 0 .039-.017l1.128-1.189a.06.06 0 0 1 .039-.016h.989q.012 0 .022.01l.757.756a.5.5 0 0 1 .146.354v1.925a.5.5 0 0 1-.146.354l-2.845 2.831h-.259l-2.845-2.83a.5.5 0 0 1-.146-.355v-1.925a.5.5 0 0 1 .146-.354l.757-.757a.03.03 0 0 1 .022-.009ZM8.745 0a4.256 4.256 0 1 1 0 8.512 4.256 4.256 0 0 1 0-8.512"
        })
    }));
};

function _define_property$N(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$N(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$N(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$N(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$N(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$N(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgFanHeart = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$N(_object_spread$N({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 18",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M10.012 9.272c.328 0 .595.266.595.595v4.521c0 .329.188.784.421 1.017l2.07 2.07c.233.233.155.421-.174.421H.596A.595.595 0 0 1 0 17.301v-1.347a6.68 6.68 0 0 1 6.683-6.682Zm9.89-3.339c.33 0 .785.19 1.017.421l2.66 2.661c.233.232.421.687.421 1.016v3.762c0 .33-.188.784-.42 1.017l-2.66 2.66c-.233.232-.689.421-1.018.421H16.14c-.328 0-.783-.189-1.016-.42l-2.66-2.66c-.233-.234-.42-.689-.42-1.018v-3.762c0-.329.187-.784.42-1.016l2.66-2.66c.233-.233.688-.422 1.016-.422zm-.59 1.426h-2.58c-.33 0-.785.188-1.018.421L13.89 9.605c-.232.233-.42.688-.42 1.017v2.581c0 .33.188.784.42 1.016l1.825 1.825c.233.233.688.422 1.017.422h2.581c.33 0 .784-.189 1.017-.422l1.825-1.825c.232-.232.421-.687.421-1.016v-2.58c0-.33-.189-.785-.42-1.018L20.328 7.78c-.233-.233-.688-.42-1.017-.42m-2.497 1.674q.023 0 .039.016l1.128 1.19a.06.06 0 0 0 .04.016.06.06 0 0 0 .039-.017l1.128-1.189a.06.06 0 0 1 .039-.016h.989q.012 0 .022.01l.757.756a.5.5 0 0 1 .146.354v1.925a.5.5 0 0 1-.146.354l-2.845 2.831h-.259l-2.845-2.83a.5.5 0 0 1-.146-.355v-1.925a.5.5 0 0 1 .146-.354l.757-.757a.03.03 0 0 1 .022-.009ZM8.745 0a4.256 4.256 0 1 1 0 8.512 4.256 4.256 0 0 1 0-8.512"
        })
    }));
};

function _define_property$M(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$M(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$M(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$M(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$M(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$M(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgFeedback = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$M(_object_spread$M({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 15 15",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M14.333 10.77c.1.266.237.518.288.786.09.484-.132.877-.495 1.165-.254.2-.373.433-.379.745 0 .061-.009.123-.02.183-.153.812-.478 1.14-1.34 1.222-1.394.132-2.793.178-4.19.065-1.212-.098-2.421-.23-3.631-.345-.45-.043-.554-.146-.555-.599-.005-2.065-.006-4.13-.011-6.195 0-.183.049-.344.232-.384.433-.096.66-.401.824-.776a5.956 5.956 0 0 1 1.317-1.904c.492-.475 1.02-.917 1.557-1.339.66-.518 1.001-1.179 1.03-2.018.009-.231.032-.465.08-.691.08-.385.33-.599.73-.662.467-.075.746.028.949.403.434.802.534 1.646.193 2.506-.26.658-.565 1.3-.842 1.951-.066.155-.118.32-.145.487-.03.19.077.315.258.356.124.029.254.044.38.042.616-.008 1.23-.029 1.845-.035.536-.005 1.066.05 1.577.227.759.263 1.125 1.041.85 1.81-.065.18-.14.357-.227.526-.079.154-.084.279.019.43.113.168.2.357.28.544.171.398.104.76-.186 1.08l-.388.42M0 10.994V8.358c0-.266.118-.356.466-.357H2.54c.343 0 .458.088.458.344v5.306c0 .262-.107.346-.452.347-.7.003-1.399.003-2.098 0-.336 0-.448-.09-.449-.35v-2.654"
        })
    }));
};

function _define_property$L(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$L(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$L(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$L(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$L(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$L(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgFlag = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$L(_object_spread$L({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 15 20",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M14.136 1.049A10.3 10.3 0 0 0 10.61.383c-1.12 0-2.109.229-2.941.68-.738.401-1.738.604-2.974.604-1.73 0-3.436-.404-4.044-.565V.333A.33.33 0 0 0 .326 0 .33.33 0 0 0 0 .333v1c0 .005.002.009.003.014 0 .004-.003.007-.003.011V19.667A.33.33 0 0 0 .326 20a.33.33 0 0 0 .326-.333V11.79c.74.188 2.36.542 4.044.542 1.343 0 2.446-.229 3.28-.68.737-.4 1.623-.604 2.635-.604 1.746 0 3.268.612 3.283.618.1.042.214.029.304-.034a.334.334 0 0 0 .143-.275v-10a.333.333 0 0 0-.205-.31"
        })
    }));
};

function _define_property$K(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$K(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$K(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$K(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$K(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$K(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgFollow = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$K(_object_spread$K({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 14 14",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "m10.96 1.304-.898.88a18.94 18.94 0 0 0-2.064-.662C4.946.906 2.093 2.92 1.495 6.07c-.548 2.895 1.468 5.827 4.39 6.387A5.54 5.54 0 0 0 12.46 8.09c.086-.433.126-.874.12-1.315-.034-1.203-.05-1.203.912-1.998.97 1.553.69 5.35-2.037 7.613a6.99 6.99 0 0 1-9.508-.544A6.995 6.995 0 0 1 1.8 2.322C4.208-.3 8.325-.79 10.96 1.304m2.044-.087.996.976-8.104 8.155-2.853-2.87 1.019-.972L5.773 8.49l7.231-7.274"
        })
    }));
};

function _define_property$J(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$J(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$J(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$J(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$J(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$J(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgFullScreen2 = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$J(_object_spread$J({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 19 19",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M18.5 0v7.5h-3V3H11V0zM0 0v7.5h3V3h4.5V0zm0 18.5V11h3v4.5h4.5v3zm18.5 0V11h-3v4.5H11v3z"
        })
    }));
};

function _define_property$I(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$I(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$I(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$I(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$I(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$I(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgFullscreen = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$I(_object_spread$I({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 17 17",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M5.8.48v2h-3v3h-2v-5h5m11 5h-2v-3h-3v-2h5v5m-11 11v-2h-3v-3h-2v5h5m11-5h-2v3h-3v2h5v-5"
        })
    }));
};

function _define_property$H(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$H(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$H(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$H(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$H(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$H(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgHelp = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$H(_object_spread$H({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 18",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M4 0h11.284a4 4 0 0 1 4 4v5.2a4 4 0 0 1-4 4h-5.24L3.214 18l2.009-4.8H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4"
        })
    }));
};

function _define_property$G(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$G(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$G(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$G(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$G(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$G(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgHome = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$G(_object_spread$G({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 21",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M15.18 5.05 10.178.073a.252.252 0 0 0-.356 0L4.821 5.049.075 9.77a.253.253 0 0 0 .178.432h1.206c.14 0 .253.113.253.252v9.88c0 .14.113.253.253.253H7.74c.139 0 .252-.113.252-.252v-5.952c0-.14.113-.253.253-.253h3.508c.14 0 .253.113.253.253v5.952c0 .139.113.252.252.252h5.776c.14 0 .253-.113.253-.252v-9.88c0-.14.113-.253.252-.253h1.207a.253.253 0 0 0 .178-.431l-4.746-4.722"
        })
    }));
};

function _define_property$F(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$F(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$F(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$F(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$F(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$F(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgIncrementTriangle = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$F(_object_spread$F({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 9 7",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "#888",
            fillRule: "evenodd",
            d: "m4.5.667 3.833 5.75H.667z"
        })
    }));
};

function _define_property$E(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$E(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$E(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$E(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$E(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$E(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgInfo = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$E(_object_spread$E({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8m9 4a1 1 0 1 1-2 0V7a1 1 0 1 1 2 0zM8 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
        })
    }));
};

function _define_property$D(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$D(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$D(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$D(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$D(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$D(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgLargeCross = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$D(_object_spread$D({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "m18.361.278 1.41 1.419L11.418 10l8.353 8.303-1.41 1.419L10 11.409l-8.361 8.313-1.41-1.419L8.582 10 .229 1.697 1.639.278l8.36 8.312L18.362.278"
        })
    }));
};

function _define_property$C(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$C(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$C(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$C(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$C(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$C(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgLive = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$C(_object_spread$C({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 14",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M19.606 0H.394A.394.394 0 0 0 0 .394v13.12c0 .217.176.393.394.393h19.212a.394.394 0 0 0 .394-.393V.394A.394.394 0 0 0 19.606 0m-9.12 8.958-3.472 2.004V2.946l3.471 2.004 3.471 2.004-3.47 2.004"
        })
    }));
};

function _define_property$B(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$B(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$B(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$B(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$B(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$B(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgLogin = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$B(_object_spread$B({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 14 14",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M14 0v14H4v-3.5h1.818v1.75h6.364V1.75H5.818V3.5H4V0zM7.04 4.5 10 6.969 7.04 9.5V7.833H0V6.167h7.04V4.5"
        })
    }));
};

function _define_property$A(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$A(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$A(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$A(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$A(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$A(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgLogout = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$A(_object_spread$A({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 14 14",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M9.632 0v3.5H7.881V1.75H1.75v10.5h6.13V10.5h1.751V14H0V0h9.632m1.262 4.375L14 6.967l-3.106 2.658v-1.75H4.378v-1.75h6.516v-1.75"
        })
    }));
};

function _define_property$z(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$z(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$z(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$z(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$z(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$z(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgMuteIcon = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$z(_object_spread$z({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 77 86",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            d: "M6.366 6.416 75.909 75.96a3.729 3.729 0 1 1-5.273 5.273L58.149 68.746l-.061 12.953a3.407 3.407 0 0 1-.035.466 3.356 3.356 0 0 1-5.419 3.1L21.943 60.697H8.762a5.027 5.027 0 0 1-3.559-1.474 5.027 5.027 0 0 1-1.474-3.56V29.748a5.03 5.03 0 0 1 1.474-3.56 5.027 5.027 0 0 1 3.56-1.474h5.354L1.092 11.69a3.729 3.729 0 1 1 5.274-5.274ZM27.78 38.377v17.287c0 .348-.036.692-.105 1.025l23.729 18.992.055-11.27A3.34 3.34 0 0 1 52 62.597zm-9.177-7.697H9.695v24.052H21.01c.247-.201.519-.362.804-.483V33.905zM54.73 0a3.4 3.4 0 0 1 .492.036l.037.006c.038.005.077.012.115.02l.064.013a3.296 3.296 0 0 1 1.097.45l.048.032c.035.023.069.046.102.07l.048.036c.028.02.056.041.083.063l.073.06a1.63 1.63 0 0 1 .14.125l.018.016.057.056c.082.083.16.17.234.26l.035.045.037.047.012.017.01.013-.003-.003-.007-.01-.016-.02-.033-.044-.036-.045.069.089.023.03.016.02.04.056.061.091a3.7 3.7 0 0 1 .138.232l.025.047.025.048a3.383 3.383 0 0 1 .112.25l.023.06a3.323 3.323 0 0 1 .136.452l.016.076a3.348 3.348 0 0 1 .066.631V42.53a3.356 3.356 0 1 1-6.712 0l-.001-32.1L35.11 23.716a3.356 3.356 0 0 1-4.246-5.198L52.609.757a3.37 3.37 0 0 1 .297-.217l.07-.045a3.131 3.131 0 0 1 .428-.222l.052-.022A3.341 3.341 0 0 1 53.84.12l.128-.033.018-.004A3.364 3.364 0 0 1 54.7 0h.03Z"
        })
    }));
};

function _define_property$y(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$y(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$y(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$y(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$y(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$y(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgMyFeed = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$y(_object_spread$y({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 17",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M24 5v12H8v-1h15V5zm-3-3v12H5v-1h15V2zm-3-2v11H0V0z"
        })
    }));
};

function _define_property$x(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$x(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$x(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$x(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$x(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$x(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgNotificationBell = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$x(_object_spread$x({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M13.93 16.09H6.11a3.91 3.91 0 1 0 7.82 0m3.747-4.654-.005-4.525A6.91 6.91 0 0 0 10.762 0H9.213a6.91 6.91 0 0 0-6.91 6.91v4.545L.07 13.687a.243.243 0 0 0-.071.172v.646c0 .134.11.244.244.244h2.06v.004h15.368v-.004h2.084c.135 0 .244-.11.244-.244v-.646a.242.242 0 0 0-.071-.172l-2.252-2.251"
        })
    }));
};

function _define_property$w(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$w(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$w(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$w(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$w(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$w(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgNotificationBellFilled = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$w(_object_spread$w({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 19 18",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M12.47 14.736a3.19 3.19 0 0 1-.971 2.307A3.4 3.4 0 0 1 9.125 18a3.4 3.4 0 0 1-2.374-.957 3.19 3.19 0 0 1-.971-2.307ZM9.074 1.191c.054 0 .084.002.084.002h.019l.028-.001h.143c1.097.017 6.349.385 6.349 5.931v3.636l1.92 1.916a.19.19 0 0 1 .077.129v.535c-.002.05-.018.222-.17.222H.76c-.17 0-.17-.235-.17-.235v-.522a.188.188 0 0 1 .062-.13l1.92-1.915V7.123c0-5.59 5.335-5.922 6.401-5.932ZM13.874 0s4.453 1.146 4.453 7.131h-1.246c0-4.743-3.207-5.863-3.207-5.863Zm-9.42 0v1.268S1.245 2.388 1.245 7.13H0C0 1.146 4.453 0 4.453 0"
        })
    }));
};

function _define_property$v(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$v(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$v(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$v(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$v(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$v(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgPadlock = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$v(_object_spread$v({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 49 64",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M24.089 0c12.163 0 21.754 12.195 21.935 27.06h2.584V64H0V27.06h2.153v-.021C2.345 12.183 11.933 0 24.09 0m.62 45.367a4.456 4.456 0 1 0 0 8.911 4.456 4.456 0 0 0 0-8.91m-.62-40.213c-8.997 0-16.6 9.651-16.773 21.906h33.546c-.174-12.255-7.777-21.906-16.773-21.906"
        })
    }));
};

function _define_property$u(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$u(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$u(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$u(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$u(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$u(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgPaidGift = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$u(_object_spread$u({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 17 16",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M17 6v10H0V6zM9.515 8c-.55 0-1.042.259-1.367.666A1.756 1.756 0 0 0 6.777 8c-.31 0-.602.083-.858.228-.548.314-.919.916-.919 1.61 0 .198.032.388.088.565.25 1.165 2.155 3.056 2.826 3.523a.407.407 0 0 0 .467 0c.67-.467 2.573-2.358 2.824-3.523.056-.177.088-.367.088-.565 0-.694-.37-1.295-.92-1.61A1.726 1.726 0 0 0 9.516 8M5 0h2v2H5Zm5 0h2v2h-2ZM0 3h17v2H0Z"
        })
    }));
};

function _define_property$t(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$t(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$t(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$t(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$t(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$t(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgPnP = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$t(_object_spread$t({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 26 18",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M23 0a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Zm0 2H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-1 7v5h-8V9z"
        })
    }));
};

function _define_property$s(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$s(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$s(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$s(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$s(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$s(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgPnP2 = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$s(_object_spread$s({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 29 21",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M26.5 0A2.5 2.5 0 0 1 29 2.5v16a2.5 2.5 0 0 1-2.5 2.5h-24A2.5 2.5 0 0 1 0 18.5v-16A2.5 2.5 0 0 1 2.5 0ZM26 3H3v15h23zm-1.5 7.5v6h-9v-6z"
        })
    }));
};

function _define_property$r(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$r(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$r(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$r(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$r(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$r(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgProfile = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$r(_object_spread$r({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 17",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M10.704 7.222a3.876 3.876 0 1 0-5.481-5.481 3.876 3.876 0 0 0 5.481 5.481m-.79 1.827H6.087A6.085 6.085 0 0 0 0 15.134v1.768h16v-1.768a6.085 6.085 0 0 0-6.085-6.085"
        })
    }));
};

function _define_property$q(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$q(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$q(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$q(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$q(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$q(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgProfileSquare = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$q(_object_spread$q({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 28 28",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M25 .5A2.5 2.5 0 0 1 27.5 3v22a2.5 2.5 0 0 1-2.5 2.5H3A2.5 2.5 0 0 1 .5 25V3A2.5 2.5 0 0 1 3 .5Zm0 1H3A1.5 1.5 0 0 0 1.5 3v22A1.5 1.5 0 0 0 3 26.5h22a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 25 1.5m-9.085 12.549A6.085 6.085 0 0 1 22 20.134v1.768H6v-1.768a6.085 6.085 0 0 1 6.086-6.085ZM11.223 6.74a3.876 3.876 0 1 1 5.481 5.481 3.876 3.876 0 0 1-5.481-5.481"
        })
    }));
};

function _define_property$p(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$p(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$p(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$p(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$p(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$p(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgRatingStarO = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$p(_object_spread$p({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 27 25",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "none",
            fillRule: "evenodd",
            stroke: props.color ? props.color : "currentColor",
            strokeWidth: 2,
            d: "M13.53 19.584 7.021 23l1.243-7.236L3 10.639l7.276-1.055L13.529 3l3.254 6.584 7.276 1.055-5.265 5.125L20.037 23z"
        })
    }));
};

function _define_property$o(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$o(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$o(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$o(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$o(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$o(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgRecastArrow = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$o(_object_spread$o({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 33 33",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M.196 17.602h28.287c.174 0 .262.209.141.333L16.917 29.969a.196.196 0 0 0 .004.277l1.858 1.808a.196.196 0 0 0 .277-.004l12.627-12.98a1.84 1.84 0 0 0 .524-1.29v-3.342c0-.485-.187-.944-.525-1.29L19.056.167a.196.196 0 0 0-.277-.003l-1.858 1.807a.196.196 0 0 0-.004.278l11.707 12.034a.196.196 0 0 1-.14.333H.195a.196.196 0 0 0-.196.196v2.592c0 .109.088.196.196.196"
        })
    }));
};

function _define_property$n(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$n(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$n(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$n(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$n(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$n(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgRecastLandscape = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$n(_object_spread$n({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 128 32",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M72.745 17.964h-6.38a.403.403 0 0 1-.406-.4V15.73l-.005-.946a.403.403 0 0 1 .407-.403h6.374c.223 0 .405.178.406.398l.01 2.782a.403.403 0 0 1-.406.403m.326-5.354a.41.41 0 0 0-.287-.117h-6.577a.409.409 0 0 0-.288.117l-2.304 2.271a.397.397 0 0 0-.12.284v7.682c0 .106.043.208.12.283l2.278 2.245a.41.41 0 0 0 .287.118h6.629a.41.41 0 0 0 .29-.119l2.252-2.244a.396.396 0 0 0 .118-.282v-1.253c0-.11-.091-.2-.204-.2h-2.03a.202.202 0 0 0-.204.2l.001 1.4a.403.403 0 0 1-.406.41h-6.23a.404.404 0 0 1-.407-.385l-.005-2.87c0-.22.182-.4.406-.4h8.699c.224 0 .407-.18.407-.4v-4.185a.397.397 0 0 0-.12-.284l-2.305-2.27m13.94 0a.424.424 0 0 0-.294-.117h-6.47a.424.424 0 0 0-.294.117l-2.335 2.246a.394.394 0 0 0-.122.283v7.708c0 .106.044.208.122.283l2.335 2.245a.426.426 0 0 0 .294.118h6.47c.11 0 .216-.043.294-.118l2.363-2.27a.395.395 0 0 0 .122-.284v-1.487c0-.112-.094-.2-.209-.2H87.18a.204.204 0 0 0-.208.2v1.645a.408.408 0 0 1-.4.4h-6.112a.41.41 0 0 1-.416-.39v-7.992a.41.41 0 0 1 .416-.39h6.078a.41.41 0 0 1 .416.392l.018.805v.848c0 .11.093.2.208.2h2.108c.115 0 .209-.09.209-.2v-1.487a.395.395 0 0 0-.122-.284l-2.363-2.27m27.4 5.455a.388.388 0 0 0-.278-.118h-5.758a.396.396 0 0 1-.393-.396v-2.601a.396.396 0 0 1 .393-.396h5.101c.209 0 .382.167.392.38l-.007 1.247c0 .11.088.2.196.2h1.987c.108 0 .196-.09.196-.2v-1.246a.421.421 0 0 0-.12-.294l-1.991-2.032a.39.39 0 0 0-.278-.117h-5.89a.387.387 0 0 0-.278.118l-1.972 2.036a.404.404 0 0 0-.113.281v2.646c0 .106.041.208.115.283l1.919 1.958a.387.387 0 0 0 .277.117h5.795c.21 0 .384.17.392.385l.001 2.73a.396.396 0 0 1-.392.384h-5.431a.395.395 0 0 1-.39-.348l-.01-1.28c0-.11-.087-.2-.196-.2h-1.986a.199.199 0 0 0-.196.2v1.253c0 .106.04.208.114.283l1.996 2.036a.39.39 0 0 0 .278.118h6.248a.388.388 0 0 0 .279-.12l1.97-2.034a.406.406 0 0 0 .115-.283V20.36a.407.407 0 0 0-.116-.284l-1.97-2.01m9.163-3.314h3.719a.2.2 0 0 0 .204-.198v-1.691a.2.2 0 0 0-.204-.198h-3.719a.201.201 0 0 1-.204-.197V8.69a.201.201 0 0 0-.205-.197h-2.014a.201.201 0 0 0-.205.197v3.778a.201.201 0 0 1-.204.197H118.7a.2.2 0 0 0-.204.198v1.665a.2.2 0 0 0 .204.198h1.988c.113 0 .204.088.204.198v7.956a.39.39 0 0 0 .121.282l2.316 2.216c.077.074.18.115.288.115h3.675a.2.2 0 0 0 .204-.198v-1.69a.2.2 0 0 0-.204-.198h-3.698a.201.201 0 0 1-.204-.194l-.021-8.264a.2.2 0 0 1 .204-.197m-22.592 5.863c0 .184-.077.36-.213.49l-2.371 2.265a.417.417 0 0 1-.287.113h-3.678a.41.41 0 0 1-.418-.42l-.001-2.867a.409.409 0 0 1 .419-.42h6.13a.41.41 0 0 1 .419.4v.44m-.014-8.005a.432.432 0 0 0-.297-.117h-6.24a.432.432 0 0 0-.296.117l-2.406 2.298a.393.393 0 0 0-.123.283v1.226c0 .11.094.2.21.2h2.123c.115 0 .21-.09.21-.2v-1.515c0-.227.197-.409.435-.4l5.979.002c.232 0 .42.18.42.401l-.001 2.538a.41.41 0 0 1-.42.4h-6.568a.43.43 0 0 0-.296.118l-2.078 1.984a.392.392 0 0 0-.123.284v2.879a.39.39 0 0 0 .123.283l2.078 1.985a.43.43 0 0 0 .296.117H98.6a.43.43 0 0 0 .29-.11l1.039-.947.013-.002 1.176-1.072v1.93c0 .111.094.2.21.2h1.958c.116 0 .21-.089.21-.2v-10.1a.392.392 0 0 0-.123-.284l-2.405-2.298m-49.314 2.92a.574.574 0 0 1-.572-.575V8.718h6.84a.34.34 0 0 1 .338.342v6.114a.356.356 0 0 1-.354.357h-6.252m5.5 2.227h.875a.91.91 0 0 0 .682-.31l1.895-2.151a.868.868 0 0 0 .25-.611V9.484c0-.23-.09-.45-.25-.612l-2.11-2.126a.855.855 0 0 0-.606-.253H51.21a.143.143 0 0 0-.142.143v2.071H48.78a.286.286 0 0 0-.285.288v16.354c0 .08.063.144.142.144h2.3a.143.143 0 0 0 .143-.144v-7.016c0-.318.256-.576.572-.576h1.96c.273 0 .526.146.664.384l4.192 7.229c.03.06.09.096.155.096h2.697c.13 0 .214-.138.155-.255l-4.322-7.454M23.519 0c.184 0 .361.073.491.203l7.896 7.856a.69.69 0 0 1 .204.489v5.187a.282.282 0 0 1-.285.283h-7.993a.282.282 0 0 1-.284-.283v-4.43a.284.284 0 0 0-.284-.283H10.056a.284.284 0 0 0-.284.282v22.413a.284.284 0 0 1-.284.283H.284A.285.285 0 0 1 0 31.717v-23.1c0-.155.128-.282.284-.282h7.759a.282.282 0 0 0 .284-.283V.282c0-.158.127-.282.284-.282ZM13.197 12.231l.015.001 18.615 10.43c.119.065.216.228.216.365v8.712c0 .137-.11.247-.246.247H23.12a.429.429 0 0 1-.382-.236l-9.51-19.406-.041-.087c-.008-.016.01-.033.025-.025Z"
        })
    }));
};

function _define_property$m(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$m(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$m(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$m(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$m(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$m(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgRecastR = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$m(_object_spread$m({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 28 28",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "m12.023 11.002 15.793 8.975a.392.392 0 0 1 .184.313v7.497a.21.21 0 0 1-.209.213H20.43a.363.363 0 0 1-.324-.203l-8.07-16.699-.034-.075c-.007-.014.008-.028.021-.021M20.51 0c.16 0 .314.064.428.177l6.885 6.875a.604.604 0 0 1 .178.427v4.539c0 .14-.11.247-.248.247h-6.97a.246.246 0 0 1-.248-.247V8.141a.248.248 0 0 0-.248-.247H8.77a.248.248 0 0 0-.248.247v19.612a.248.248 0 0 1-.248.247H.248A.249.249 0 0 1 0 27.752V7.541c0-.136.111-.248.248-.248h6.766a.246.246 0 0 0 .248-.247V.247c0-.139.11-.247.247-.247Z"
        })
    }));
};

function _define_property$l(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$l(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$l(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$l(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$l(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$l(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgRecastText = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$l(_object_spread$l({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 79 19",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M24.25 11.471h-6.38a.403.403 0 0 1-.407-.4V9.237l-.004-.946a.403.403 0 0 1 .406-.403h6.374c.224 0 .406.178.406.399l.01 2.782a.403.403 0 0 1-.405.402m.326-5.354A.41.41 0 0 0 24.288 6h-6.577a.409.409 0 0 0-.287.117L15.119 8.39a.397.397 0 0 0-.119.283v7.682c0 .106.043.208.12.284l2.277 2.245a.41.41 0 0 0 .288.117h6.628a.41.41 0 0 0 .29-.119l2.252-2.244a.396.396 0 0 0 .118-.282v-1.253c0-.11-.09-.2-.203-.2h-2.03a.202.202 0 0 0-.204.2v1.4a.403.403 0 0 1-.405.41H17.9a.404.404 0 0 1-.406-.385l-.006-2.87c0-.22.183-.4.407-.4h8.698c.225 0 .407-.18.407-.4V8.672a.397.397 0 0 0-.12-.283l-2.304-2.272m13.94 0A.424.424 0 0 0 38.22 6h-6.47a.424.424 0 0 0-.293.118l-2.336 2.245a.394.394 0 0 0-.122.283v7.708c0 .106.044.208.122.284l2.336 2.245a.426.426 0 0 0 .294.117h6.47c.11 0 .216-.042.294-.117l2.362-2.271a.395.395 0 0 0 .122-.284v-1.487c0-.111-.093-.2-.208-.2h-2.109a.204.204 0 0 0-.207.2v1.645a.408.408 0 0 1-.4.4h-6.112a.41.41 0 0 1-.417-.39V8.504a.41.41 0 0 1 .417-.39h6.077a.41.41 0 0 1 .417.393l.018.804v.849c0 .11.092.2.207.2h2.109c.115 0 .208-.09.208-.2V8.672a.395.395 0 0 0-.122-.283l-2.362-2.271m27.399 5.455a.388.388 0 0 0-.277-.117h-5.759a.396.396 0 0 1-.392-.396V8.458a.396.396 0 0 1 .392-.396h5.102c.208 0 .381.167.392.38l-.008 1.247c0 .111.088.2.196.2h1.987c.109 0 .196-.09.196-.2V8.444a.421.421 0 0 0-.12-.295l-1.99-2.032A.39.39 0 0 0 65.355 6h-5.889a.387.387 0 0 0-.279.119l-1.971 2.035a.404.404 0 0 0-.114.282v2.645c0 .107.042.209.115.284l1.92 1.958a.387.387 0 0 0 .277.117h5.794c.211 0 .384.17.392.384l.001 2.73a.396.396 0 0 1-.392.384h-5.431a.395.395 0 0 1-.389-.348l-.01-1.279c0-.111-.088-.2-.196-.2h-1.986a.199.199 0 0 0-.197.2v1.252c0 .106.041.208.115.283l1.996 2.037a.39.39 0 0 0 .278.117h6.247a.388.388 0 0 0 .28-.12l1.97-2.034a.406.406 0 0 0 .114-.283v-2.696a.407.407 0 0 0-.115-.283l-1.97-2.01m9.162-3.315h3.72A.2.2 0 0 0 79 8.062V6.37a.2.2 0 0 0-.204-.198h-3.719a.201.201 0 0 1-.204-.197V2.198A.201.201 0 0 0 74.67 2h-2.015a.201.201 0 0 0-.204.198v3.777a.201.201 0 0 1-.205.197h-2.04A.2.2 0 0 0 70 6.37v1.666a.2.2 0 0 0 .204.197h1.988c.113 0 .205.088.205.198v7.957a.39.39 0 0 0 .12.281l2.317 2.217c.076.073.18.114.287.114h3.675a.2.2 0 0 0 .204-.198v-1.69a.2.2 0 0 0-.204-.198H75.1a.201.201 0 0 1-.205-.194l-.02-8.263a.2.2 0 0 1 .203-.198m-22.592 5.863c0 .184-.076.36-.212.49L49.9 16.877a.417.417 0 0 1-.286.113h-3.678a.41.41 0 0 1-.419-.42v-2.867a.409.409 0 0 1 .418-.42h6.13a.41.41 0 0 1 .42.4v.44m-.014-8.005A.432.432 0 0 0 52.175 6h-6.24a.432.432 0 0 0-.297.117l-2.406 2.298a.393.393 0 0 0-.123.283v1.227c0 .11.094.2.21.2h2.123c.116 0 .21-.09.21-.2V8.409c0-.227.197-.409.435-.4l5.98.002c.231 0 .42.18.419.402v2.538a.41.41 0 0 1-.42.4h-6.568a.43.43 0 0 0-.297.118l-2.078 1.984a.392.392 0 0 0-.123.283v2.88a.39.39 0 0 0 .123.283l2.078 1.984a.43.43 0 0 0 .297.117h4.605a.43.43 0 0 0 .29-.11l1.04-.947.012-.002 1.177-1.072v1.93c0 .112.094.201.21.201h1.958c.116 0 .21-.09.21-.2V8.698a.392.392 0 0 0-.123-.283L52.47 6.117M3.157 9.038a.574.574 0 0 1-.572-.576V2.225h6.84a.34.34 0 0 1 .339.342v6.114a.356.356 0 0 1-.355.357H3.157m5.501 2.226h.874a.91.91 0 0 0 .682-.309l1.895-2.152a.868.868 0 0 0 .251-.611V2.99c0-.23-.09-.45-.251-.612L9.999.253A.855.855 0 0 0 9.393 0H2.715a.143.143 0 0 0-.143.144v2.07H.286A.286.286 0 0 0 0 2.503v16.354c0 .08.064.144.142.144h2.3a.143.143 0 0 0 .143-.144V11.84c0-.318.257-.576.572-.576h1.96c.274 0 .527.147.665.385l4.191 7.228c.03.06.09.096.155.096h2.698c.13 0 .214-.138.155-.255l-4.323-7.454"
        })
    }));
};

function _define_property$k(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$k(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$k(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$k(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$k(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$k(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgRefund = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$k(_object_spread$k({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M3.72 12a.42.42 0 0 1 .42.402c.214 4.18 3.772 7.515 8.114 7.515 1.932 0 3.698-.66 5.09-1.753h-1.516a.42.42 0 0 1-.427-.417v-1.25c0-.23.191-.417.427-.417h4.744c.236 0 .428.187.428.417v4.622c0 .23-.192.417-.428.417H19.29a.42.42 0 0 1-.428-.417v-1.434c-.167.134-.34.246-.517.348A10.37 10.37 0 0 1 12.262 22C6.743 22 2.233 17.746 2 12.432A.426.426 0 0 1 2.432 12Zm13.179-5c.052 0 .095.045.095.1l-.001 4.39c0 .017-.013.03-.029.03h-2.37c-.025 0-.046-.021-.046-.048v-.042l-.001-1.366c0-.055-.043-.1-.095-.1h-3.52a.1.1 0 0 0-.096.1l-.007 4.411a.13.13 0 0 0 .127.134h3.457a.137.137 0 0 0 .134-.14V12.81c0-.038.029-.068.065-.068l2.324.003c.057 0 .086.073.045.115l-3.822 4.035a.33.33 0 0 1-.24.104H8.095A.097.097 0 0 1 8 16.9v-4.685c0-.054.03-.131.067-.17l4.711-4.974A.26.26 0 0 1 12.941 7zm-4.625-5C17.501 2 21.78 6.254 22 11.568a.415.415 0 0 1-.41.432h-1.221a.407.407 0 0 1-.398-.402c-.205-4.18-3.578-7.515-7.697-7.515A7.54 7.54 0 0 0 7.45 5.836h1.456c.224 0 .406.187.406.417v1.25c0 .23-.182.417-.406.417h-4.5A.41.41 0 0 1 4 7.503V2.88c0-.23.182-.417.406-.417h1.216c.224 0 .406.187.406.417v1.434q.158-.134.324-.245A9.52 9.52 0 0 1 12.274 2"
        })
    }));
};

function _define_property$j(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$j(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$j(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$j(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$j(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$j(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgRewind10 = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$j(_object_spread$j({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 21 24",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M11 0v3.012c5.567.261 10 4.857 10 10.488C21 19.299 16.299 24 10.5 24 4.796 24 .154 19.452.004 13.784L0 13.5h3a7.5 7.5 0 1 0 8-7.484V10L2 5zM8.516 11.716V17.5H7.78v-5.12h-.768v-.664h1.504m3.264-.088c.741 0 1.261.257 1.56.772.299.515.448 1.23.448 2.148 0 .933-.15 1.659-.448 2.176-.299.517-.819.776-1.56.776-.747 0-1.27-.259-1.568-.776-.299-.517-.448-1.243-.448-2.176 0-.917.15-1.633.448-2.148.299-.515.821-.772 1.568-.772m0 .664c-.363 0-.639.099-.828.296-.19.197-.315.457-.376.78a6.44 6.44 0 0 0-.092 1.18c0 .48.03.883.092 1.208.061.325.187.587.376.784.19.197.465.296.828.296.357 0 .63-.099.82-.296.19-.197.315-.459.376-.784s.092-.728.092-1.208c0-.464-.03-.857-.092-1.18-.061-.323-.187-.583-.376-.78-.19-.197-.463-.296-.82-.296"
        })
    }));
};

function _define_property$i(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$i(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$i(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$i(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$i(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$i(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgSad = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$i(_object_spread$i({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 44 46",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "#000",
            fillRule: "evenodd",
            d: "M32.16 0 44 11.531V44a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V11.336h11.069V0h21.09m-8.968 34c-3.94 0-7.23 1.074-9.83 3.23a1 1 0 0 0 1.276 1.54c2.223-1.844 5.06-2.77 8.554-2.77 3.5 0 5.884.592 7.153 1.693a1 1 0 1 0 1.31-1.51C29.947 34.7 27.127 34 23.192 34m8.37-16.27-.353.354-2.71 2.71-2.708-2.71-.354-.354-.707.707.354.354 2.709 2.709-2.71 2.709-.353.354.707.707.354-.354 2.709-2.71 3.063 3.064.707-.707-.354-.354-2.71-2.71 2.71-2.708.354-.354-.708-.707m-13 0L15.5 20.794l-2.708-2.71-.354-.354-.707.707.354.354 2.71 2.709-3.064 3.063.707.707.354-.354 2.708-2.71 2.71 2.71.354.354.707-.707-.354-.354-2.71-2.71 2.71-2.708.354-.354-.707-.707"
        })
    }));
};

function _define_property$h(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$h(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$h(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$h(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$h(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$h(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgScreencast = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$h(_object_spread$h({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 26 21",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "m13 15 6 6H7zM23 0a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-3.178v-2H23a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h3.377v2H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
        })
    }));
};

function _define_property$g(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$g(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$g(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$g(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$g(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$g(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgSearch = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$g(_object_spread$g({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 18 18",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "m17.704 16.285-3.399-3.39a7.917 7.917 0 0 0 1.69-4.898 7.997 7.997 0 1 0-7.998 7.998 7.917 7.917 0 0 0 4.899-1.69l3.389 3.4a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"
        })
    }));
};

function _define_property$f(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$f(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$f(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$f(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$f(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$f(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgShare = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$f(_object_spread$f({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 14 16",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M11.637 4.689c-.11 0-.252.044-.327 0-1.44-.926-2.458.128-3.543.753-.832.469-1.66.947-2.48 1.448-.819.5-.85 1.27 0 1.77 1.387.838 2.777 1.666 4.207 2.427.372.157.79.167 1.17.027a2.245 2.245 0 0 1 2.705.611c.692.722.783 1.832.217 2.657a2.125 2.125 0 0 1-2.351 1.067c-1.099-.226-1.683-.979-1.878-2.174a1.43 1.43 0 0 0-.576-.886 70.952 70.952 0 0 0-4.193-2.453 1.59 1.59 0 0 0-1.169-.053c-1.2.443-2.254.23-2.958-.713a2.32 2.32 0 0 1 0-2.776c.704-.939 1.771-1.156 2.958-.713.383.13.8.11 1.169-.053.987-.496 1.909-1.112 2.874-1.643.965-.532 1.9-.988 2.023-2.4C9.583.45 11.018-.186 12.17.048a2.391 2.391 0 0 1 1.82 2.555 2.307 2.307 0 0 1-2.352 2.086"
        })
    }));
};

function _define_property$e(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$e(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$e(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$e(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$e(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$e(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgStream = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$e(_object_spread$e({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 29 22",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M0 16.5a5 5 0 0 1 5 5H3a3 3 0 0 0-3-3zm0-4a9 9 0 0 1 9 9H7a7 7 0 0 0-7-7zm0-4c7.18 0 13 5.82 13 13h-2c0-6.075-4.925-11-11-11zM26 0l.164.005A2.5 2.5 0 0 1 28.5 2.5v16l-.005.164A2.5 2.5 0 0 1 26 21H15.217v-3H25.5V3h-22v2.5h-3v-3l.005-.164A2.5 2.5 0 0 1 3 0z"
        })
    }));
};

function _define_property$d(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$d(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$d(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$d(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$d(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$d(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgThreeCasts = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$d(_object_spread$d({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 112.667 64",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "#1E211D",
            fillRule: "evenodd",
            d: "M73.283 37.186v10.61c0 .5-.408.905-.912.905H48.81a.862.862 0 0 1-.865-.86l.052-28.23c.006-.353.3-.64.657-.64h23.98c.358 0 .647.287.647.64l.013 8.742v.268c0 .17.14.308.312.308h16.148a.196.196 0 0 0 .197-.194l.005-.96V.64A.644.644 0 0 0 89.31 0H62.337c-.357 0-.851.202-1.104.453L29.124 32.284c-.253.25-.457.74-.457 1.093V63.36c0 .354.29.641.647.641H62.19c.613 0 1.2-.241 1.633-.67l26.047-25.82a.433.433 0 0 0-.31-.74l-15.84-.018a.436.436 0 0 0-.438.434M16.49 42.611v3.98c0 .187-.151.339-.337.339H7.444a.32.32 0 0 1-.32-.323l.02-10.586a.244.244 0 0 1 .243-.24h8.862a.24.24 0 0 1 .239.24l.005 3.278v.1c0 .064.051.116.115.116h5.968c.04 0 .072-.032.073-.073l.002-.36V28.907a.24.24 0 0 0-.24-.24h-9.968a.66.66 0 0 0-.408.17L.17 40.773a.666.666 0 0 0-.169.41v11.243c0 .133.107.24.24.24h12.15a.85.85 0 0 0 .603-.25l9.626-9.683a.163.163 0 0 0-.114-.278l-5.854-.006a.162.162 0 0 0-.162.162m90 9.334v3.979c0 .187-.151.339-.337.339h-8.708a.32.32 0 0 1-.32-.323l.02-10.586a.244.244 0 0 1 .243-.24h8.862a.24.24 0 0 1 .239.24l.005 3.278v.1c0 .064.051.116.115.116h5.968c.04 0 .072-.032.073-.072l.002-.36V38.24a.24.24 0 0 0-.24-.24h-9.968a.66.66 0 0 0-.408.17L90.17 50.107a.666.666 0 0 0-.169.41V61.76c0 .132.107.24.24.24h12.15a.85.85 0 0 0 .603-.252l9.626-9.682a.163.163 0 0 0-.114-.278l-5.854-.006a.162.162 0 0 0-.162.163"
        })
    }));
};

function _define_property$c(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$c(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$c(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$c(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$c(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$c(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgThreeDotsVertical = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$c(_object_spread$c({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 2 10",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M1 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        })
    }));
};

function _define_property$b(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$b(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$b(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$b(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$b(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$b(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgTicket = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$b(_object_spread$b({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 32",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "#00E8D0",
            fillRule: "evenodd",
            d: "M25 0v32H0V0h5.338C6.544 2.827 9.297 4.8 12.5 4.8s5.956-1.974 7.162-4.8z"
        })
    }));
};

function _define_property$a(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$a(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$a(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$a(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$a(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$a(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgTicketBlank = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$a(_object_spread$a({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 25 32",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            d: "M25 0v32H0V0h5.338C6.544 2.827 9.297 4.8 12.5 4.8s5.956-1.974 7.162-4.8z"
        })
    }));
};

function _define_property$9(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$9(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$9(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$9(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$9(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$9(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgVerified = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$9(_object_spread$9({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "none",
            stroke: props.color ? props.color : "currentColor",
            strokeMiterlimit: 10,
            strokeWidth: 2,
            d: "M20 6 9 17l-5-5",
            clipRule: "evenodd"
        })
    }));
};

function _define_property$8(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$8(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$8(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$8(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$8(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$8(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgVideoFilter = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$8(_object_spread$8({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 12",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M17.582.04A6.425 6.425 0 0 1 24 6.457a6.425 6.425 0 0 1-6.417 6.417c-3.269 0-5.97-2.459-6.363-5.624l2.14-2.101c-.13.415-.22.85-.22 1.308a4.448 4.448 0 0 0 4.443 4.443 4.448 4.448 0 0 0 4.443-4.443 4.447 4.447 0 0 0-4.443-4.442 4.4 4.4 0 0 0-2.356.69c.001-.025.008-.047.008-.073V.491A6.367 6.367 0 0 1 17.582.04ZM12.552 0c.329 0 .595.267.595.595v2.363c0 .2-.099.385-.265.496l-2.728 2.68-1.677 1.648a.596.596 0 0 0-.265.495v4.002a.595.595 0 0 1-.595.595H5.53a.595.595 0 0 1-.595-.595V8.277c0-.199-.1-.385-.265-.495L.265 3.454A.595.595 0 0 1 0 2.958V.595C0 .267.266 0 .595 0Zm2.604 3.589c0-.402.435-.653.783-.452l4.97 2.869c.347.2.347.702 0 .903l-4.97 2.869a.522.522 0 0 1-.783-.452Z"
        })
    }));
};

function _define_property$7(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$7(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$7(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$7(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$7(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgVideoPlayButton = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$7(_object_spread$7({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 14 18",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M14 9 0 18V0z"
        })
    }));
};

function _define_property$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$6(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$6(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgVideoSort = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$6(_object_spread$6({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 12",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M12.552 0c.329 0 .595.267.595.595v2.363c0 .2-.099.385-.265.496l-2.728 2.68-1.677 1.648a.596.596 0 0 0-.265.495v4.002a.595.595 0 0 1-.595.595H5.53a.595.595 0 0 1-.595-.595V8.277c0-.199-.1-.385-.265-.495L.265 3.454A.595.595 0 0 1 0 2.958V.595C0 .267.266 0 .595 0zM16.9 10.655c.055 0 .1.146.1.326v1.3c0 .18-.045.325-.1.325h-6.8c-.055 0-.1-.145-.1-.325v-1.3c0-.18.045-.326.1-.326h6.8m4.933-2.916c.092 0 .167.146.167.326v1.3c0 .18-.075.325-.167.325H10.167c-.092 0-.167-.146-.167-.325v-1.3c0-.18.075-.326.167-.326h11.666m1.9-2.916c.148 0 .267.145.267.324v1.301c0 .18-.12.325-.267.325H12.267c-.149 0-.268-.145-.268-.324l1.8-1.626h9.934"
        })
    }));
};

function _define_property$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$5(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgVolume1 = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$5(_object_spread$5({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 18 17",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M4.081 5.841H.172v5.533h3.909L8.996 16V1L4.08 5.841M11 0c3.921 0 7 3.848 7 8.5S14.921 17 11 17v-2c2.706 0 5-2.867 5-6.5S13.706 2 11 2zm0 5c1.487 0 2.692 1.567 2.692 3.5S12.487 12 11 12Z"
        })
    }));
};

function _define_property$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$4(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$4(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgWarning = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$4(_object_spread$4({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 64.76 59.391",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M34.314.5a4 4 0 0 1 1.567 1.567l28.38 51.39a4 4 0 0 1-3.501 5.934H4a4 4 0 0 1-3.502-5.933l28.38-51.391A4 4 0 0 1 34.314.499M32.8 40.682c-2.146 0-3.747 1.491-3.747 3.565s1.6 3.565 3.747 3.565 3.747-1.491 3.747-3.565-1.6-3.565-3.747-3.565m3.093-18.809h-6.185v7.786l.4 8.731h5.384l.4-8.731v-7.786"
        })
    }));
};

function _define_property$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$3(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$3(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgWatchAgain = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$3(_object_spread$3({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 15 12",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "m12.477 0-.001 5.245h2.358l-3.5 6-3.5-6h2.642V2H2v8h7.477v2H0V0h12.477"
        })
    }));
};

function _define_property$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$2(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$2(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgWatchTriangle = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$2(_object_spread$2({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 10 10",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "evenodd",
            d: "M10 5 0 10V0z"
        })
    }));
};

function _define_property$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property$1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props$1(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgWidget = function(props) {
    return /*#__PURE__*/ jsx("svg", _object_spread_props$1(_object_spread$1({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 18 18",
        role: "img"
    }, props), {
        children: /*#__PURE__*/ jsx("path", {
            fill: props.color ? props.color : "currentColor",
            fillRule: "nonzero",
            d: "M7.56 8.37H.803A.81.81 0 0 1 0 7.56V.803C0 .36.36 0 .803 0H7.56c.442 0 .803.36.803.803V7.56a.805.805 0 0 1-.803.81m9.6 0h-6.757a.803.803 0 0 1-.803-.802V.803C9.6.36 9.96 0 10.403 0h6.757c.442 0 .802.36.802.803V7.56a.81.81 0 0 1-.802.81M7.56 18H.803A.805.805 0 0 1 0 17.19v-6.758c0-.442.36-.802.803-.802H7.56c.442 0 .803.36.803.802v6.758a.8.8 0 0 1-.803.81Zm2.4-4.005c0-.045.03-.112.06-.143l4.193-4.162c.03-.03.097-.06.142-.06h3.517c.046 0 .083.037.083.082v3.675c0 .015-.015.023-.022.023h-2.108c-.022 0-.037-.015-.037-.037v-1.178a.083.083 0 0 0-.083-.082h-3.127a.083.083 0 0 0-.083.082l-.007 3.69c0 .06.052.113.112.113h3.075c.067 0 .12-.053.12-.12V14.49c0-.03.023-.06.06-.06h2.07c.052 0 .075.06.037.098l-3.397 3.374a.336.336 0 0 1-.232.098h-4.298a.083.083 0 0 1-.082-.082v-3.923z"
        })
    }));
};

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SvgClose = function(props) {
    return /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        role: "img"
    }, props), {
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: props.color ? props.color : "currentColor",
                d: "m4.34 2.93 12.73 12.73-1.41 1.41L2.93 4.35z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: props.color ? props.color : "currentColor",
                d: "M17.07 4.34 4.34 17.07l-1.41-1.41L15.66 2.93z"
            })
        ]
    }));
};

export { SvgAddEmoji as AddEmoji, SvgArrowDown as ArrowDown, SvgBackArrow as BackArrow, SvgBought as Bought, SvgCalendar as Calendar, SvgCastCredit as CastCredit, SvgCategories as Categories, SvgChannelPass as ChannelPass, SvgChannels as Channels, SvgCheckCircleFilled as CheckCircleFilled, SvgClose as Close, SvgCog as Cog, SvgCross as Cross, SvgDataProfile as DataProfile, SvgDelete as Delete, SvgEventCalendar as EventCalendar, SvgEventCountdown as EventCountdown, SvgExchangeChannelPass as ExchangeChannelPass, SvgFan as Fan, SvgFanHeart as FanHeart, SvgFeedback as Feedback, SvgFlag as Flag, SvgFollow as Follow, SvgFullScreen2 as FullScreen2, SvgFullscreen as Fullscreen, SvgHelp as Help, SvgHome as Home, SvgIncrementTriangle as IncrementTriangle, SvgInfo as Info, SvgLargeCross as LargeCross, SvgLive as Live, SvgLogin as Login, SvgLogout as Logout, SvgMuteIcon as MuteIcon, SvgMyFeed as MyFeed, SvgNotificationBell as NotificationBell, SvgNotificationBellFilled as NotificationBellFilled, SvgPadlock as Padlock, SvgPaidGift as PaidGift, SvgPnP as PnP, SvgPnP2 as PnP2, SvgProfile as Profile, SvgProfileSquare as ProfileSquare, SvgRatingStarO as RatingStarO, SvgRecastArrow as RecastArrow, SvgRecastLandscape as RecastLandscape, SvgRecastR as RecastR, SvgRecastText as RecastText, SvgRefund as Refund, SvgRewind10 as Rewind10, SvgSad as Sad, SvgScreencast as Screencast, SvgSearch as Search, SvgShare as Share, SvgStream as Stream, SvgThreeCasts as ThreeCasts, SvgThreeDotsVertical as ThreeDotsVertical, SvgTicket as Ticket, SvgTicketBlank as TicketBlank, SvgVerified as Verified, SvgVideoFilter as VideoFilter, SvgVideoPlayButton as VideoPlayButton, SvgVideoSort as VideoSort, SvgVolume1 as Volume1, SvgWarning as Warning, SvgWatchAgain as WatchAgain, SvgWatchTriangle as WatchTriangle, SvgWidget as Widget };
